<template>
  <CCard class="user-manager-card">
    <CCardHeader class="user-manager-card__header-container">
      <slot name="header">
        <div class="user-manager-card__header">
          <slot name="header-data"></slot>
          <CInput
            v-if="!hideSearchBar"
            class="user-manager-card__header-input"
            :class="{ 'mr-0': hideAddButton }"
            size="sm"
            :placeholder="searchPlaceholder"
            :value="$route.query.search"
            @input="onInputSearch"
            @keyup.enter="onInputSearch($event.target.value)"
            @keyup.esc="onInputSearch()"
          />
          <span
            v-if="!hideAddButton"
            class="cursor-poiner"
            @click="addItem"
          >
            <CIcon
              name="add"
              size="xl"
            />
          </span>
        </div>
      </slot>
    </CCardHeader>
    <CCardBody class="user-manager-card__body">
      <CDataTable
        class="user-manager"
        :items="items"
        :fields="fields"
        :items-per-page="10"
        :pagination="false"
        :loading="loading"
        @row-clicked="toggleRow"
        ref="table"
      >
        <template #action-header>
          <span></span>
        </template>

        <template #check-header>
          <div
            v-if="!hideCheckHeader"
            class="user-manager__checked-counter"
            :class="{ 'user-manager__checked-counter_not-zero': checkedRowsCount > 0 }"
            @click="toggleAll"
          >{{ checkedRowsCount || '' }}</div>
        </template>

        <template #rowId={item}>
          <td
            :data-row-id="item[checkKey]"
          ></td>
        </template> 

        <template #check={item}>
          <td
            class="checkbox"
            :data-row-id="item[checkKey]"
          >
            <CInputCheckbox
              class="user-manager__row-checkbox"
              size="lg"
              custom
              :checked="isChecked[item[checkKey]]"
            />
          </td>
        </template>

        <template #user_avatar="{item}">
          <td>
            <div class="user-manager__avatart">
              <img :src="getUserAvatar(item)" />
            </div>
          </td>
        </template>

        <template #comment="{item}">
          <td>
           <span v-if="!item.isEdit">{{ item.comment }}</span>
           <div v-else class="d-flex">
            <CInput
            
            class="user-manager-card__header-input edit-input"
            :class="{ 'mr-0': hideAddButton }"
            size="sm"
            :value="item.comment"
            v-model="item.comment"
            @keyup.enter="onInputEdit(item, $event.target.value)"
          />
          <button
            class="edit-comment-submit"
            @click="onEditSubmit(item)"
          >
          </button>
          <button
            class="edit-comment-close"
            @click="onEditClose(item)"
          >
          </button>
          
           </div>
           
          </td>
        </template>

        <template #last_comment="{item}">
          <td class="user-manager__last-comment-column">
            <div v-if="item.last_comment ">
              {{ item.last_comment  }}
            </div>
            <div v-else class="text-dark-blue car-card__empty">No comment</div>
            <VSeeAllLink :to="`/comments?search=${item.user_username}`" />
          </td>
        </template>

        <template #carListing="{item}">
          <td class="user-manager__car-listing-column">
            <VDraftCarCard v-if="item.type === 'draft'" :car="getCar(item)" />
            <VCarCard v-else :car="getCar(item)" />
          </td>
        </template>

        <template #verification="{item}">
          <td class="verification">
            <span v-if="item.verification" class="verification-status">{{item.verification === 'approved' ? 'Added' : ''}}</span>
            <span v-if="item.verification === 'declined' && item.verificationDescription" class="verification-description"><br>{{item.verificationDescription}}</span>
            <CDropdown
              v-if="!item.verification"
              togglerText="-"
              addTogglerClasses="verification-dropdown"
              addMenuClasses="verification-dropdown-menu"
            >
              <CDropdownItem @click="() => onVerificationStateChange(item, 'approved')">Create T3 Marketplace Listing</CDropdownItem>
              <CDropdownItem @click="() => onVerificationStateChange(item, 'declined')">Declined</CDropdownItem>
            </CDropdown>
          </td>
        </template>

        <template #verificationState="{item}">
          <td class="verification-status"><CBadge class="user-manager__car-verification-state" :color="item.verficationStateColor">{{item.verificationState}}</CBadge></td>
        </template>

        <template #comments="{item}">
          <td class="comments" :class="item && item.comments && item.comments.length > 0 ? 'has-comments' : ''">
            <a  @click="openComments(item)" class="cursor-pointer" v-if="item && item.comments && item.comments.length > 0">View Comments</a>
            <span v-else>No Comment</span>
          </td>
        </template>
        <template #type="{ item }">
          <td>
            <span :class="item.type === 'sellItForMe' ? 'sell-for-me' : 'auction'">
              {{ item.type === 'sellItForMe' ? 'Sell It For Me' : item.type === 't3marketplace' ? 'Marketplace' : 'Auction' }}
            </span>
          </td>
        </template>

        <template #action={item}>
          <td>
            <CDropdown
              :placement="items.length <= 1 ? 'top-end' : 'bottom-end'"
            >
              <template #toggler>
                <CButton class="toggler">
                  <CIcon name="dots" />
                </CButton>
              </template>
              <CDropdownItem
                v-if="onEditItem"
                class="btn btn-info"
                @click.stop="editItem(item)"
              >Edit</CDropdownItem>
              <CDropdownItem
                v-if="onMoveItem"
                class="btn btn-info"
                @click.stop="moveItem(item, 'sellYourEv')"
              >Send to Auction</CDropdownItem>
              <CDropdownItem
                v-if="onMoveItem"
                class="btn btn-info"
                @click.stop="moveItem(item, 't3marketplace')"
              >Send to Marketplace</CDropdownItem>
              <CDropdownItem
                v-if="onDeleteItem"
                class="btn btn-danger"
                @click.stop="deleteItem(item)"
              >Delete</CDropdownItem>
            </CDropdown>
          </td>
        </template>

        <template #link="{item}">
          <td>
            <a
              :class="{ 'auction-manager__disabled-link': !item.link }"
              :href="item.link"
              target="blank"
            >
              Link
            </a>
          </td>
        </template>

        <template #marketplaceLink="{item}">
          <td>
            <a
              v-if="item.marketplaceLink"
              :href="item.marketplaceLink"
              target="blank"
            >
              Marketplace Link
            </a>
          </td>
        </template>
        <template #evbidsUrl="{item}">
          <td>
            <a
              v-if="item.evbidsUrl"
              :href="item.evbidsUrl"
              target="blank"
            >
            EV Bids Link
            </a>
          </td>
        </template>

        <template #show_details="{item, index}">
          <td class="py-2 comment">
            <div>
              {{ getFirstLine(item.comment) }}
            </div>
            <CButton
              v-if="item.comment.length > 35"
              color="primary"
              square
              size="sm"
              class="see-all-link"
              @click.stop="toggleDetails(item, index)"
            >
              {{Boolean(item._toggled) ? 'Hide' : 'Show full'}}
            </CButton>
          </td>
        </template>

        <template #details="{item}">
          <CCollapse :show="Boolean(item._toggled)" :duration="collapseDuration">
            <div class="p-3">
              {{ item.comment }}
            </div>
          </CCollapse>
        </template>
        
        <template #user_username="{item}">
          <td class="username">
            <a :href="getUserLink(item.user_username)" target="_blank">{{item.user_username}}</a>
          </td>
        </template>

        <template #username="{item}">
          <td class="username">
            <a :href="getUserLink(item.username)" target="_blank">{{item.username}}</a>
          </td>
        </template>
        
        <template #seller="{item}">
          <td>
            <a :href="getUserLink(item.seller)" target="_blank">{{item.seller}}</a>
          </td>
        </template>

        <template #buyer="{item}">
          <td>
            <a :href="getUserLink(item.buyer)" target="_blank">{{item.buyer}}</a>
          </td>
        </template>
        <template #state="{item}">
          <td class="last-bid">
            <select
                class="form-control"
                name="state"
                :id="item.id"
                :value="item.state"
                @change="handleState"
              >
               <option value="">Select State</option>
                <option
                  v-for="option in item.states"
                  :key="option"
                  :value="option"
                  >{{ option }}</option
                >
              </select>
          </td>
        </template>
        <template #lastBid="{item}">
          <td class="last-bid">
            <div>{{item.lastBid.bid}}</div>
            <div v-if="item.lastBid.info" class="last-bid-info">{{item.lastBid.info}}</div>
          </td>
        </template>
        <template #isTestMode={item} v-if="onChangeCheckBoxInput">
          <td
            class="featured-status"
            :data-row-id="item.id"
          >
          <!-- <input type="checkbox" class="user-manager__row-checkbox" :id="`${item.id}`"
              :name="`${item.id}`" :checked="item.isTestMode"  @change="onChangeCheckBoxInput"/> -->

            <CInputCheckbox
              :id="`${item.id}`"
              :name="`${item.id}`"
              size="lg"
              custom
              :checked="item.isTestMode === 1 ? true : false"
            />
          </td>
        </template>
      </CDataTable>
    </CCardBody>
    <CCardFooter class="user-manager-card__footer">
      <slot name="footer" class="footer"></slot>
    </CCardFooter>
  </CCard>
</template>

<script>
import { createTableStoreMixin, tableStore } from '@/mixins/tableMixin'
import VCarCard from './UserManager/VCarCard'
import {
  DEFAULT_USER_AVATAR
} from '@/utils/dictionaries/car'
import {
  toggleRowClass
} from '@/utils/table/toggleRowClass'
import { getUserLink } from '@/utils/validation/user'
import VDraftCarCard from './UserManager/VDraftCarCard.vue'
const defaultImage = "https://evbids.blob.core.windows.net/assets/images/NoImage.jpg";

export default {
  name: 'Table',

  mixins: [
    createTableStoreMixin()
  ],

  components: {
    VCarCard,
    VDraftCarCard
},

  props: {
    items: Array,
    handleChangeState:{
      type: Function
    },
    hideAddButton: {
      type: Boolean,
      defalt: false
    },
    hideSearchBar: {
      type: Boolean,
      defalt: false
    },
    name: {
      type: String,
      defalt: 'default-table'
    },
    fields: {
      type: Array,
      default () {
        return []
      }
    },
    caption: {
      type: String,
      default: 'Table'
    },
    searchPlaceholder: {
      type: String,
      default: 'Search'
    },
    hideCheckHeader: Boolean,
    checkKey: {
      type: String,
      default: 'id'
    },
    checkedRows: {
      type: Array,
      default: () => ([])
    },
    loading: {
      type: Boolean,
      default: false
    },
    onToggleRow: {
      type: Function
    },
    onChangeCheckBoxInput: {
      type: Function
    },
    onEditClose: {
      type: Function
    },
    onEditSubmit: {
      type: Function
    },
    onToggleAll: {
      type: Function
    },
    onInputSearch: {
      type: Function
    },
    onInputEdit: {
      type: Function
    },
    onEditItem: {
      type: Function
    },
    onMoveItem: {
      type: Function
    },
    onShowComments: {
      type: Function
    },
    onDeleteItem: {
      type: Function
    },
    onClickToAdd: {
      type: Function
    },
    onVerificationStateChange: {
      type: Function
    }
  },

  computed: {
    isChecked () {
      return this.checkedRows
        .map(item => item[this.checkKey])
        .reduce((acc, item) => {
          acc[item] = true
          return acc
        }, {})
    },

    checkedRowsCount () {
      return this.checkedRows.length
    },
  },

  watch: {
    checkedRows (rows, oldRows) {
      if (!this.$refs.table) return
      const rowsSelector = rows.reduce((acc, item) => `[data-row-id="${item[this.checkKey]}"],` + acc, '').replace(/,$/, '')
      const rowsEl = rowsSelector.length > 0 ? this.$refs.table.$el.querySelectorAll(rowsSelector) : []

      const allRowsSelector = this.items.reduce((acc, item) => `[data-row-id="${item[this.checkKey]}"],` + acc, '').replace(/,$/, '')
      const allRowsEl = allRowsSelector.length > 0 ? this.$refs.table.$el.querySelectorAll(allRowsSelector) : []

      Array.from(allRowsEl).forEach(row => {
        if (row.parentNode.nodeName === 'TR') {
          toggleRowClass(row.parentNode, 'user-manager__row-checked', false)
        }
      })

      Array.from(rowsEl).forEach(row => {
        if (row.parentNode.nodeName === 'TR') {
          toggleRowClass(row.parentNode, 'user-manager__row-checked')
        }
      })
    }
  },

  data: () => ({
    collapseDuration: 0,
    getUserLink: getUserLink,
  }),

  methods: {
    handleState(e){
      this.handleChangeState(e.target.value, e.target.id)
    },
    openComments(item){
      this.onShowComments(item)
    },
    getUserAvatar (item) {
      return item.user_avatar || DEFAULT_USER_AVATAR
    },
    getCar (row) {
      return row.car || {
        id: row.last_car_id,
        endDate: row.last_car_end_date,
        startDate: row.last_car_start_date,
        title: row.last_car_title,
        imageUrl: row.first_car_image_url || defaultImage,
        verified: row.car_verified,
        uuid: row.uuid,
        year: row.year,
        make: row.make,
        model: row.model
      }
    },
    toggleRow (item, index, columName, event) {
      if(columName === 'isTestMode'){
        this.onChangeCheckBoxInput(item)
      }else{
        if (this.checkedRows.includes(item) && event.path && event.path.some(el => el?.classList?.contains('toggler'))) return
      if (this.onToggleRow) this.onToggleRow({ item, index, columName, event })
      this[tableStore.mutationTypes.MUTATION_SET_CHECKED_ROW]([this.name, item])
      }

    },
    toggleAll () {
      if (this.onToggleAll) this.onToggleAll(this.items)
      this[tableStore.mutationTypes.MUTATION_SET_CHECKED_ROWS]([this.name, this.items])
    },
    inputSearch (event) {
      debugger
      if (this.onInputSearch) this.onInputSearch(event.target.value)
    },
    moveItem (item, type) {
      if (this.onMoveItem) this.onMoveItem(item, type)
      this[tableStore.mutationTypes.MUTATION_UNSET_CHECKED_ROWS](this.name)
    },
    editItem (item) {
      if (this.onEditItem) this.onEditItem(item)
      this[tableStore.mutationTypes.MUTATION_UNSET_CHECKED_ROWS](this.name)
    },
    deleteItem (item) {
      if (item) this.onDeleteItem(item)
      this[tableStore.mutationTypes.MUTATION_UNSET_CHECKED_ROWS](this.name)
    },
    addItem () {
      if (this.onClickToAdd) this.onClickToAdd()
    },
    toggleDetails (item) {
      const selectedItem = this.items.find(_item => _item.id === item.id)
      this.$set(selectedItem, '_toggled', !item._toggled)
      this.collapseDuration = 300
      this.$nextTick(() => { this.collapseDuration = 0 })
    },
    getFirstLine (str = '') {
      const strLength = 70
      return str.length > strLength ? `${str.slice(0, strLength)}...` : str
    },
  }
}
</script>
<style>
.has-comments{
  text-decoration: underline;
  color: #109CF1;
}
.edit-comment-submit, .edit-comment-close{
  border: none;
}
.edit-comment-submit{
  border:1px solid #27AE60;
  background: #27AE60;
}
.edit-comment-close{
  margin-left: 0px;
  border:1px solid #27AE60;
  background: transparent;
}
.edit-comment-submit::before{
  content: "\2713";
}
.edit-comment-close::before{
  content: "\2715";
}
.edit-input input{
  border-top-right-radius: 0 !important;
    border-bottom-right-radius: 0 !important;
}
</style>
